import { useState } from "react";

const today = () => new Date().toLocaleDateString("en-CA");

export function parseAmountCents(value) {
  const normalized = value.trim().replace(",", ".");
  if (!normalized) return null;
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) throw new Error("Informe um valor com até duas casas decimais.");
  const [whole, fraction = ""] = normalized.split(".");
  const cents = Number(whole) * 100 + Number(fraction.padEnd(2, "0"));
  if (!Number.isSafeInteger(cents) || cents <= 0 || cents > 100000000) throw new Error("Valor fora do limite permitido.");
  return cents;
}

export default function CommercialPaymentForm({ onSubmit, busy = false }) {
  const [payment, setPayment] = useState({ payment_date: today(), payment_method: "PIX", payment_notes: "", payment_link: "", days: "30", amount: "" });
  const [error, setError] = useState("");
  const change = (key) => (event) => setPayment((current) => ({ ...current, [key]: event.target.value }));
  const submit = async (event) => {
    event.preventDefault();
    try {
      const amount_cents = parseAmountCents(payment.amount);
      setError("");
      await onSubmit({ payment_date: payment.payment_date, payment_method: payment.payment_method,
        payment_notes: payment.payment_notes, payment_link: payment.payment_link,
        days: Number(payment.days), amount_cents });
    } catch (cause) { setError(cause.message); }
  };
  const input = "mt-1.5 w-full rounded-lg border border-[#282C37] bg-[#0A0B0E] px-3 py-2 text-amber-50";
  return <form onSubmit={submit} className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
    <label className="text-sm">Data<input type="date" required value={payment.payment_date} onChange={change("payment_date")} className={input} /></label>
    <label className="text-sm">Método<select value={payment.payment_method} onChange={change("payment_method")} className={input}><option>PIX</option><option value="LINK_CARTAO">Link de cartão</option><option>OUTRO</option></select></label>
    <label className="text-sm">Período<select value={payment.days} onChange={change("days")} className={input}><option value="7">7 dias</option><option value="15">15 dias</option><option value="30">30 dias</option></select></label>
    <label className="text-sm">Valor recebido (R$, opcional)<input inputMode="decimal" value={payment.amount} onChange={change("amount")} placeholder="Ex.: 99,90" className={input} /></label>
    <label className="text-sm">Link de pagamento<input type="url" value={payment.payment_link} onChange={change("payment_link")} className={input} /></label>
    <label className="text-sm">Observações<input value={payment.payment_notes} onChange={change("payment_notes")} className={input} /></label>
    {error && <p role="alert" className="text-sm text-red-300 sm:col-span-2 xl:col-span-3">{error}</p>}
    <button disabled={busy} className="rounded bg-[#D4AF37] text-black px-3 py-2 font-semibold disabled:opacity-60 sm:col-span-2 xl:col-span-3">Registrar pagamento</button>
  </form>;
}
